<template>
    <div class="container">
      <div class="dropdown-container">
        <!-- Select Company -->
        <div class="dropdown-item">
          <label for="companyId">Company</label>
          <select id="companyId" v-model="selectedCompany" class="scrollable-dropdown">
            <option disabled value="">Select Company</option>
            <option v-for="company in CompanyList" :key="company.id" :value="company.id">
              {{ company.company_name }}
            </option>
          </select>
        </div>

        <!-- Change Status -->
        <div class="form-check form-switch">
            <input class="form-check-input p-0 toggle-switch" type="checkbox" id="isActive" v-model="isActive">
            <label class="form-check-label" for="isActive">Active</label>
        </div>

        <!-- Select Org Structure -->
        <div class="dropdown-item">
          <label for="orgStructure">Org Structure<span class="req">*</span></label>
          <select id="orgStructure" v-model="selectedOrgStructure" class="scrollable-dropdown" required disabled>
            <option disabled value="">Select Structure</option>
            <option v-for="org in OrgStructureList" :key="org.id" :value="org.id">
              {{ org.description }}
            </option>
          </select>
        </div>

        <!-- Select User Role -->
        <div class="dropdown-item">
          <label for="userRole">User Role<span class="req">*</span></label>
          <ValidationProvider name="Role" rules="required">
            <multiselect
              v-model="selectedRole"
              :options="filteredRoles"
              :searchable="true"
              :allow-empty="true"
              placeholder="Select Role"
              label="name"
              track-by="id"
              @search-change="filterRoles"
              class="multiselect custom-multiselect"
              ></multiselect>
          </ValidationProvider>
        </div>

        <!-- Select ReportingTo -->
        <div class="dropdown-item">
          <label for="Reportingto">Reporting to<span class="req">*</span></label>
          <ValidationProvider name="Reportingto" rules="required">
            <multiselect
              v-model="selectedReporting"
              :options="filteredReporting"
              :searchable="true"
              :allow-empty="true"
              placeholder="Select Reporting to"
              label="name"
              track-by="ProfileId"
              @search-change="filterReporting"
              class="multiselect custom-multiselect"
              ></multiselect>
          </ValidationProvider>
        </div>

        <!-- Select Title -->
        <div class="dropdown-item">
          <label for="Title">Title</label>
          <select id="title" v-model="title" class="scrollable-dropdown">
            <option disabled value="">Select Title</option>
            <option v-for="title in TitleList" :key="title.label" :value="title.label">
              {{ title.label }}
            </option>
          </select>
        </div>

        <!-- Pick Date of Birth -->
        <div class="dropdown-item">
          <label for="Title">Date of Birth</label>
          <input type="date" placeholder="Enter DOB" v-model="dob" required>
        </div>

        <!-- Enter first name -->
        <div class="dropdown-item">
          <label for="Title">First Name<span class="req">*</span></label>
          <input type="text" placeholder="Enter First Name" v-model="first_name" required>
        </div>

        <!-- Enter last name -->
        <div class="dropdown-item">
          <label for="Title">Last Name</label>
          <input type="text" placeholder="Enter Last Name" v-model="last_name">
        </div>

        <!-- Enter email address -->
        <div class="dropdown-item">
          <label for="Title">Email</label>
          <input type="email" placeholder="Enter Email" v-model="email" required>
        </div>

        <!-- Enter mobile number -->
        <div class="dropdown-item">
          <label for="Title">Mobile Number<span class="req">*</span></label>
          <input type="text" placeholder="Enter Mobile Number" v-model="mobile" required>
        </div>

        <!-- Enter Address line 1 -->
        <div class="dropdown-item">
          <label for="Title">Address1<span class="req">*</span></label>
          <input type="text" placeholder="Enter Address1" v-model="address1" required>
        </div>

        <!-- Enter Address line 2 -->
        <div class="dropdown-item">
          <label for="Title">Address2</label>
          <input type="text" placeholder="Enter Address2" v-model="address2">
        </div>

        <!-- Enter City -->
        <div class="dropdown-item">
          <label for="city">City</label>
          <input type="text" placeholder="Enter City" v-model="city">
        </div>
      </div>

      <!-- Select distributor -->
      <div v-if="showDistributorForm" class="dropdown-container">
        <div class="dropdown-item " >
          <label for="district">District<span class="req">*</span></label>
          <select id="district" v-model="selectedDistrict" class="scrollable-dropdown" required>
            <option disabled value="">Select District</option>
            <option v-for="district in DistrictList" :key="district.id" :value="district.id">
              {{ district.name }}
            </option>
          </select>
        </div>
        <div class="dropdown-item">
          <label for="businessName">Business Name</label>
          <input type="text" placeholder="Enter Business Name" v-model="business_name">
        </div>
  
        <div>
          <div class="dropdown-item" style="display:flex; align-items:center; margin: 10px;">
            <input type="checkbox" class="checkbox" id="vat" v-model="isCheckedVat" :true-value="1" :false-value="0">
            <label for="vat" style="margin-left:10px;">VAT</label>
            <div v-if="isCheckedVat" class="dropdown-item">
              <input type="text" id="svat" placeholder="Enter VAT Number" v-model="vat_no" style="margin-left:30px;">
            </div>
          </div>
          <div class="dropdown-item" style="display:flex; align-items:center; margin: 10px;">
            <input type="checkbox" class="checkbox" id="svat" v-model="isCheckedSvat" :true-value="1" :false-value="0">
            <label for="svat" style="margin-left:10px;">SVAT</label>
            <div v-if="isCheckedSvat" class="dropdown-item">
              <input type="text" id="svat" placeholder="Enter SVAT Number" v-model="svat_no" style="margin-left:20px;">
            </div>
          </div>
          <div class="dropdown-item" style="display:flex; align-items:center; margin: 20px 10px 10px 0;">
            <input type="checkbox" class="checkbox" id="minsInvoice" v-model="is_minus_invoice" :true-value="1" :false-value="0">
            <label for="minsInvoice" style="margin-left:10px;">Allow Minus Stocks</label>
          </div>
        </div>
      </div>

      <!-- Enter Remark -->
      <div class="dropdown-container">
        <div class="dropdown-item">
          <label for="Title">Remark</label>
          <input type="text" placeholder="Enter Remark" v-model="remark">
        </div>
  
      </div>

      <!-- Form action buttons -->
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-danger m-4" @click="Cancel">Cancel</button>
        <button type="button" class="btn btn-success m-4" @click="updateUser" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span v-if="!loading">Update</span>
          <span v-else> Updating...</span>
        </button>
      </div>
    </div>
  </template>

  <script>
  import { ref, watch, computed } from "vue";
  import { fetchUserRoleListForUserForm, fetchOrgStructureListForUserForm, fetchReportingToListForUserForm,fetchCompanyListForUserForm,fetchDistrictListForUserForm,fetchUserDetailsByRoleId,updateUser} from '@/services/dataService';
  import Multiselect from 'vue-multiselect';
  import { useToast } from "vue-toastification";
  
  export default {
    components: { Multiselect },
    data() {
      const dob = new Date().toISOString().split('T')[0];
      return {
        loading: false,
        token: localStorage.getItem('token_set') || '',
        userId: this.$route.params.id || 1,
        first_name: "",
        last_name: "",
        email: "",
        mobile: "",
        remark:"",
        address1:"",
        address2:"",
        city:"",
        business_name:"",
        dob,
        selectedCompany: "",
        selectedOrgStructure: "",
        selectedReporting:"",
        selectedDistrict: "",
        title:"",
        CompanyList:[],
        OrgStructureList: [],
        ReportingToList:[],
        distributorList: [],
        DistrictList:[],
        selectedRole: null,
        searchRole: '',
        UserRoleList: [],
        filteredRoles: [],
        filteredReporting:[],
        showDistributorForm: false,
        isCheckedVat: 0,
        isCheckedSvat: 0,
        is_minus_invoice:0,
        svat_no: '',
        vat_no:'',
        isActive:false,
        TitleList: [
          { id: 1, label: "Mr" },
          { id: 2, label: "Mrs" },
          { id: 3, label: "Miss" },
          { id: 4, label: "Ms" }
        ]
      };
    },

    created() {
      this.loadRoleList();
      this.loadOrgStructure();
      this.loadCompany();
      this.loadDistrict(); 
      this.loadUserDetails();
      this.loadReportiong();
    },

    mounted(){
      this.loadOrgStructureAtFirst();
    },
  
    watch: {
      selectedOrgStructure(newVal) {
        if (newVal) {
        this.successmessage = "";
        this.loadReportiong();
        this.getFieldsByOrgStructure();
        
        // Fix: Ensure showDistributorForm is updated correctly
        this.showDistributorForm = newVal == 13;
        }
    },
      isCheckedVat(newVal) {
        if (newVal === 0) {
          this.vat_no = '';
        }
      },
      isCheckedSvat(newVal) {
        if (newVal === 0) {
          this.svat_no = ''; 
        }
      },
        selectedRole(newVal) {
        if (newVal) {
          this.successmessage = "";
        }
      },
        selectedReporting(newVal) {
        if (newVal) {
          this.successmessage = "";
        }
      }
    },
  
    methods: {
      async loadCompany() {
        try {
          const response = await fetchCompanyListForUserForm(this.token);
          this.CompanyList = response.data.data || [];
          console.log('Fetched CompanyList:', this.CompanyList);
        } catch (error) {
          console.error('Error fetching CompanyList:', error);
        }
      },
  
      async loadDistrict() {
        try {
          const response = await fetchDistrictListForUserForm(this.token);
          this.DistrictList = response.data.data || [];
          console.log('Fetched DistrictList:', this.DistrictList);
        } catch (error) {
          console.error('Error fetching DistrictList:', error);
        }
      },
  
      async loadRoleList() {
        try {
          const response = await fetchUserRoleListForUserForm(this.token);
          this.UserRoleList = response.data.data || [];
          this.filteredRoles = [...this.UserRoleList]; // Initialize filtered list
          console.log("filtered user roles for loading :", this.filteredRoles)
          this.loadUserDetails();

        } catch (error) {
          console.error('Error fetching user roles:', error);
        }
      },
  
      filterRoles(query) {
        this.filteredRoles = this.UserRoleList.filter(user =>
          user.name.toLowerCase().includes(query.toLowerCase())
        );
        console.log("filtered roles in filterrole method :",this.filteredRoles)
      },
      
      async loadReportiong(){
        try{
          const response = await fetchReportingToListForUserForm(this.token,this.selectedOrgStructure,);
          this.ReportingToList = response.data.data || [];
          this.filteredReporting = [...this.ReportingToList];
          console.log("filtered user reporting for loading :", this.filteredReporting);
          this.loadUserDetails();

        }
        catch(error){
          console.error("Error fetching reporting to list ",error);
        }
      },
  
      filterReporting(query) {
        this.filteredReporting = this.ReportingToList.filter(user =>
          user.name.toLowerCase().includes(query.toLowerCase())
        );

        console.log("filtered user reporting for loading",this.filteredReporting)
      },
  
      async loadOrgStructure() {
        try {
          const response = await fetchOrgStructureListForUserForm(this.token);
          this.OrgStructureList=response.data.data||[];
          console.log('Fetched OrgStructureList:', this.OrgStructureList);
        } catch (error) {
          console.error('Error fetching org structure list:', error);
        }
      },

      async loadOrgStructureAtFirst(){
        try {
          const response = await fetchOrgStructureListForUserForm(this.token);
          this.OrgStructureList=response.data.data||[];
          console.log('Fetched OrgStructureList:', this.OrgStructureList);
        } catch (error) {
          console.error('Error fetching org structure list:', error);
        }

        const response = await fetchUserDetailsByRoleId(this.userId, this.token);
        const details = response.data.data;
        this.selectedOrgStructure = details.org_struct_id;
        if (this.selectedOrgStructure === 13) {
          this.showDistributorForm = true;
        }
        else{
          this.showDistributorForm = false;
        }
      },
  
      getFieldsByOrgStructure() {
        if (this.selectedOrgStructure === 13) {
          this.showDistributorForm = true;
        }
        else{
          this.showDistributorForm = false;
        }
      },

      async loadUserDetails() {
        try {
            const response = await fetchUserDetailsByRoleId(this.userId, this.token);
            const userData = response.data.data;
            if (userData) {

            this.isActive = userData.is_active === '1';
            this.selectedCompany = userData.company_id;
            this.title = userData.title;
            this.first_name = userData.first_name;
            this.last_name = userData.last_name;
            this.email = userData.email;
            this.mobile = userData.mobile;
            this.address1 = userData.address1;
            this.address2 = userData.address2;
            this.city= userData.city;
            this.business_name = userData.business_name;
            this.dob = userData.dob;

            this.selectedDistrict = userData.district_id;


            this.is_minus_invoice = userData.is_minus_invoice;
            this.isCheckedVat = userData.vat_liable;
            this.isCheckedSvat = userData.svat_liable;
            this.vat_no = userData.vat_no;
            this.svat_no = userData.svat_no;

            this.remark = userData.remark;

            console.log("user data ",userData.role_id)

            console.log(typeof userData.role_id, userData.role_id);
            console.log(typeof userData.reporting_to, userData.reporting_to);


            let num = Number(userData.role_id);
            console.log(typeof num, num);

            let num2 = String(userData.reporting_to);
            console.log(typeof num2, num2);



            this.selectedRole = this.filteredRoles.find((item) => item.id === num);

            console.log("filter roles to in load details method ",this.filteredRoles);


            this.selectedReporting= this.filteredReporting.find((item1) => item1.ProfileId === num2);

            console.log("selected reporting to ",this.selectedReporting)

            console.log("filter eporting to in load details method ",this.filteredReporting);

            console.log()
            console.log("--------" ,selectedRole);

            }
        } catch (error) {
            console.error("Error fetching user details:", error);
        }
      },

      validateFields() {
        const requiredFields = [
          { value: this.first_name, name: "First Name" },
          { value: this.mobile, name: "Mobile Number" },
          { value: this.selectedRole, name: "User Role" },
          { value: this.selectedReporting, name: "Reporting To" },
          { value: this.selectedOrgStructure, name: "Org Structure" },
        ];

        for (let field of requiredFields) {
          if (!field.value || field.value === "") {
            useToast().error(`${field.name} is required`);
            return false;
          }
        }

        // Check distributor form if visible
        if (this.showDistributorForm) {
          if (!this.selectedDistrict) {
            useToast().error("District is required");
            return false;
          }
        }

        return true;
      },

      async updateUser() {
        if (!this.validateFields()) return; // Stop if validation fails

        this.loading = true; // Start loading

        const payload = {
          is_active: this.isActive ? "1" : "0",
          dob: this.dob,
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          mobile: this.mobile,
          remark: this.remark,
          address1: this.address1,
          address2: this.address2,
          title: this.title,
          city: this.city,
          district_id: this.selectedDistrict,
          business_name: this.business_name,
          vat_liable: this.isCheckedVat,
          svat_liable: this.isCheckedSvat,
          vat_no: this.vat_no,
          svat_no: this.svat_no,
          is_minus_invoice: this.is_minus_invoice,
          company_id: this.selectedCompany,
          org_struct_id: this.selectedOrgStructure,
          role_id: this.selectedRole.id,
          reporting_to: this.selectedReporting.ProfileId
        };

        try {
          await updateUser(this.userId, this.token, payload);
          useToast().success("User updated successfully!");
          this.$router.push('/users');
        } catch (error) {
          console.error("Error response:", error.response);
          if (error.response && error.response.data && error.response.data.errors) {
            Object.values(error.response.data.errors).forEach((messages) => {
              messages.forEach((message) => {
                useToast().error(message);
              });
            });
          } else {
            useToast().error("Failed to save user data.");
          }
        } finally {
          this.loading = false; // Stop loading
        }
      },

      Cancel() {
        this.$router.push('/users');
      }
    }
  };
  
</script>
  
<style scoped>
.form-check {
  display: flex;
  align-items: center; 
  gap: 10px;
}
  
  .req {
    color: red;
    margin-left: 5px;
  }
  
  .checkbox{
    width: 15px;
    height: 15px;
    border: 2px solid #007bff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    color: #007bff;
    background-color: white;
    border-radius: 4px;
    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
    position: relative;
  }
  
  .custom-multiselect .multiselect__select {
    background-color: #f0f0f0 !important; /* Change the background color */
    color: #333 !important; /* Change the text color */
  }
  
  .custom-multiselect .multiselect__option--highlight {
    background-color: #007bff !important; /* Change the highlight color */
    color: #fff; /* Change the text color of highlighted option */
  }
  
  .custom-multiselect .multiselect__option {
    background-color: #fff !important; /* Change the background color of options */
    color: #333; /* Change the text color of options */
  }
  
  /* Ensure the body and html take the full height of the page */
  html, body {
    height: 100%;
    margin: 0;
    padding: 0;
    background-color: #f0f0f0; /* Background color for the page */
  }
  
  .scrollable-dropdown {
    max-height: 50px; /* Adjust height for 10 items */
    overflow-y: auto;
  }
  
  .d-flex {
    display: flex;
    flex-direction: row;
    width: 100%;
  }
  
  .toggle-switch {
    /* background-color: red; */
    transition: 0.3s;
  }
  
  .form-check-input {
    /* background-color: red !important; */
    /* border-color: red !important; */
    transition: 0.3s;
  }
  
  .form-check-input::before {
    background-color: white !important;
  }
  
  .form-check-input:checked {
    background-color: #069E27 !important;
    border-color: #069E27 !important;
  }
  
  .toggle-switch:checked {
    background-color: #069E27;
  }
  
  /* Container for the entire section */
  .container {
    background-color: #ffffff;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 20px;
    margin: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; /* Center items vertically */
    height: 100%; /* Take full height of the page */
    width: 100%; /* Take full width of the page */
    box-sizing: border-box; /* Ensure padding doesn't affect width */
  }
  
  /* Loading spinner styles */
  .loading-spinner {
    font-size: 18px;
    text-align: center;
    margin-top: 20px;
    color: #007bff; /* Preserved color for spinner */
  }
  
  /* Container for dropdowns and search box */
  .dropdown-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* 4 columns for each row */
    gap: 15px; /* Adjust spacing between items */
    width: 100%; /* Ensure container takes full width */
    justify-content: center; /* Center dropdowns horizontally */
    margin-bottom: 20px; /* Space between dropdowns and table */
  }
  
  /* Each dropdown item with label */
  .dropdown-item {
    flex: 1;
    min-width: 50%; /* Minimum width for each dropdown item */
    max-width: 75%; /* Maximum width for each dropdown item */
  }
  
  /* Styling for labels */
  label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
    font-size: 14px; /* Adjust font size for better readability */
  }
  
  
  /* Style the Multiselect container */
  .multiselect {
    width: 100%;
    min-height: 40px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background: white;
    font-size: 14px;
  }
  
  /* Style the selected values inside Multiselect */
  .multiselect__tags {
    padding: 8px;
    display: flex;
    flex-wrap: wrap;
    background: white;
    border-radius: 5px;
    cursor: pointer;
  }
  
  /* Style the dropdown list */
  .multiselect__content-wrapper {
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  /* Style each option inside the dropdown */
  .multiselect__option {
    padding: 10px;
    transition: background 0.2s;
  }
  
  .multiselect__option--highlight {
    background: #007bff;
    color: white;
  }
  
  /* Placeholder text style */
  .multiselect__placeholder {
    color: #999;
    font-size: 14px;
  }
  
  /* Remove default focus outline */
  .multiselect:focus-within {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
  }
  
  
  /* Styling for select elements */
  select {
    width: 100%; /* Ensure select takes full width of its container */
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-size: 14px; /* Adjust font size for better readability */
    transition: border-color 0.3s, box-shadow 0.3s;
  }
  
  input{
    width: 100%; /* Ensure select takes full width of its container */
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-size: 14px; /* Adjust font size for better readability */
    transition: border-color 0.3s, box-shadow 0.3s;
  }
  
  input[type="date"] {
    width: 100%; /* Ensure select takes full width of its container */
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-size: 14px; /* Adjust font size for better readability */
    transition: border-color 0.3s, box-shadow 0.3s;
  }
  
  input[type="text"] {
    width: 100%; /* Ensure select takes full width of its container */
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-size: 14px; /* Adjust font size for better readability */
    transition: border-color 0.3s, box-shadow 0.3s;
  }
  
  /* Focus styling for select elements */
  select:focus {
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
    outline: none;
  }
  
  input[type="text"]:focus {
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
    outline: none;
  }
  
  input[type="date"]:focus {
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
    outline: none;
  }
  
  input[type="email"]:focus {
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
    outline: none;
  }
  
  /* Styling for search input */
  .search-input {
    flex: 1;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-size: 14px; /* Adjust font size for better readability */
    transition: border-color 0.3s, box-shadow 0.3s;
    width: 75%;
  }
  
  /* Focus styling for search input */
  .search-input:focus {
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
    outline: none; /* Remove the default outline */
  }
  
  /* Styling for search button */
  .search-container {
    display: flex;
    align-items: center;
    justify-content: left;
  }
  
  .btn.button-default {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    background-color: #007bff;
    color: #ffffff;
    font-size: 14px; /* Adjust font size for better readability */
    cursor: pointer;
    transition: background-color 0.3s, transform 0.3s;
  }
  
  .btn.button-default:hover {
    background-color: #0056b3;
    transform: scale(1.05);
  }
  
  .btn.button-default:active {
    transform: scale(0.95);
  }
  
  /* Tiles container */
  .tiles-container {
    display: flex;
    justify-content: space-around;
    width: 100%;
    margin-top: 20px;
  }
  /* Styling for the "eye" icon */
  .fa-eye {
    cursor: pointer;
    transition: color 0.3s, transform 0.3s; /* Smooth transition for color and transform */
  }
  
  /* Hover effect for the "eye" icon */
  .fa-eye:hover {
    color: #0056b3; /* Darker shade on hover */
    transform: scale(1.2); /* Slightly enlarge the icon on hover */
  }
  
  /* Active effect for the "eye" icon */
  .fa-eye:active {
    transform: scale(1.1); /* Slightly shrink the icon on click */
  }
  
  /* Tile styling */
  .tile {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 10px; /* Reduced padding */
    text-align: center;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
    flex: 1;
    margin: 0 5px; /* Reduced margin */
    max-width: 250px; /* Reduced max-width */
    position: relative;
    transition: transform 0.3s, box-shadow 0.3s;
  }
  
  .tile:hover {
    transform: translateY(-5px);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  }
  
  .tile-header {
    display: flex;
    justify-content: center; /* Center the content horizontally */
    align-items: center; /* Center the content vertically */
    flex-direction: column; /* Stack the title and icon vertically */
  }
  
  .corner-icon {
    font-size: 24px;
    color: #007bff;
    margin-top: 5px; /* Add some space between the title and the icon */
  }
  
  .tile h5 {
    margin: 0;
    font-size: 18px;
    color: #333;
    text-align: center; /* Center the text */
  }
  
  .tile-span-total{
    display: block;
    margin-top: 10px;
    font-size: 24px;
    font-weight: bold;
    color: #0f2c5f;
  }
  
  .tile-span-paid{
    display: block;
    margin-top: 10px;
    font-size: 24px;
    font-weight: bold;
    color: #154422;
  }
  
  .tile-span-due {
    display: block;
    margin-top: 10px;
    font-size: 24px;
    font-weight: bold;
    color: #e90707;
  }
  
  .tile-sales {
    background-color: #C9E6F0; /* Light green */
  }
  
  .tile-paid {
    background-color: #C4DAD2; /* Light green */
  }
  
  .tile-due-payment {
    background-color: #EAC7C7; /* Light red */
  }
  
  /* New styles for items grid */
  .items-grid {
    display: flex; /* Use flexbox */
    flex-wrap: wrap; /* Allow items to wrap if needed */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    margin: 0 auto; /* Center container */
    gap: 16px; /* Add spacing between items */
    text-align: center; /* Center text in items if applicable */
  }
  
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    background-color: #f9f9f9;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    min-width: 100px; /* Ensure items have a minimum width */
  }
  
  .item-name {
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  .item-count {
    font-size: 18px;
    color: #007bff;
  }
  
  /* Table styling */
  .table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed; /* Ensure table cells take up the full width */
  }
  
  .table th, .table td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }
  
  .table th {
    background-color: #f9f9f9;
    font-weight: bold;
  }
  
  .table td {
    background-color: #ffffff;
  }
  </style>